import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Prodege from '../components/prodege/Prodege'
import {
  selectAccountProfile,
  selectTokenProfile
} from '../store/selectors/common'

const ProdegeContainer = () => {
  const { t } = useTranslation()

  const accountProfile = useSelector(selectAccountProfile)
  const tokenProfile = useSelector(selectTokenProfile)

  return (
    <Prodege
      t={t}
      authId={accountProfile.authId}
      symbol={tokenProfile.symbol}
    />
  )
}

export default ProdegeContainer
